import React from 'react';
import { MarketingTeacher } from '../../../domain/teacher';
import { routes } from '../../../domain/websiteDomain';
import Button from '../../common/button';

interface TeacherCTAProps {
  teacher: MarketingTeacher;
}

const TeacherCTA: React.FC<TeacherCTAProps> = ({ teacher }) => {
  return (
    <div className="flex flex-col items-center justify-center bg-white content py-32px lg:py-48px space-y-32px">
      <div className="text-3xl text-center">
        Practice with <span className="font-family-bold">{teacher.name}</span>
      </div>
      <Button
        buttonStyle="primary"
        href={routes.SIGNUP}
        classes="w-full sm:w-max"
      >
        Start your 7 day trial
      </Button>
    </div>
  );
};

export default TeacherCTA;
